export default __webpack_public_path__ + "7847054fd8d7d54d67379843090d7ae3.webp";